import { useStore } from '@stores';
import { useEffect } from 'react';

export const useTechnicalCategoryBookmark = (orderId?: string) => {
  const { technicalCategoryStore } = useStore();
  const { selectedCategoryId, bookmarked } = technicalCategoryStore;

  useEffect(() => {
    selectedCategoryId &&
      orderId &&
      technicalCategoryStore.getTechnicalCategoryBookmark({
        technicalCategoryId: selectedCategoryId,
        orderId,
      });
  }, [technicalCategoryStore, selectedCategoryId, orderId]);

  return bookmarked;
};
